import { z } from "zod";
import {
  GRADE_NAME,
  NO_OF_STUDENT,
  SECTION,
  SECTION_NAME,
  YEAR
} from "./consts";

export const schema = z.object({
  [GRADE_NAME]: z.string().min(1, "This field is required"),
  [YEAR]: z.string().min(1, "This field is required"),
  [SECTION]: z
    .object({
      _id: z.string().optional(),
      [SECTION_NAME]: z.string().min(1, "This field is required"),
      [NO_OF_STUDENT]: z
        .string()
        .min(1, "This field is required")
        .refine(
          (val) => !isNaN(Number(val)) && Number(val) > 0,
          "Number of students must be a positive number"
        ),
    })
    .array()
    .min(1, "At least one section is required"),
});


export type formValues = z.infer<typeof schema>;
